import React from 'react';

import { TPageProps } from '../../../page-props';
import CommunityPage from '../../../templates/community';

export default (props: TPageProps) => <CommunityPage {...props} />;
